module.exports = __webpack_public_path__ + "0619afe183af41be59649e62d4cffbb5.svg";